import gql from 'graphql-tag';

export const DEACTIVATE_DOC = gql`
  mutation ($id: ID!) {
    deactivateDocument(id: $id)
  }
`;

export const ESIGNATURE_EVENT_NOTIFICATIONS = gql`
  query ($entityType: String!, $entityId: ID!) {
    esignatureEventNotifications(entityType: $entityType, entityId: $entityId) {
      accountId
      vendorOpportunityId
      templateId
      templateName
      envelopeId
      status
      retryCount
      generatedDateTime
      statusChangedDateTime
    }
  }
`;
